<template>
  <div class="email-address-change">
    <base-heading :underline="false">
      {{ $t('userAccount.emailChange.emailChangeTitle') }}
    </base-heading>
    <div class="change-address-form">
      <validation-observer ref="changeEmail"
                           tag="form"
                           @submit.prevent="submitChangeEmail">
        <div class="form-fields">
          <base-v-input v-model.trim="emailInput"
                        id="changeEmail"
                        ref="email"
                        name="email"
                        variant="white"
                        :placeholder="this.oldEmail"
                        :submitted="changeEmailSubmitted"
                        :label="$t('userAccount.emailChange.emailChangeLabel')"
                        rules="required|noSpaces|email"
                        vid="email">
          </base-v-input>
          <base-v-input v-model.trim="passwordInput"
                        id="currentPassword"
                        name="currentPassword"
                        rules="required"
                        :submitted="changeEmailSubmitted"
                        :label="$t('registration.passwordLabel')"
                        revealPassword
                        variant="white"
                        type="password"
                        maxlength="20"
                        vid="password"
                        ref="password"/>
          <base-button :disabled="!changeEmailFormFilled || buttonDisabled" :loading="dataLoading" class="save-btn"
                       type="submit">
            {{ $t('userAccount.emailChange.saveChangesButton') }}
          </base-button>
        </div>
      </validation-observer>
    </div>
    <confirmation-modal :visible="confirmEmailChangeVisible"
                        confirm-type="email"
                        @close="resetData"
                        :confirm-title="$t('registration.emailConfirmation.title')"
                        :dynamic-data-description="$t('registration.emailConfirmation.changeEmailDescription', { emailInput: this.emailInput })"
                        :confirm-text="$t('registration.emailConfirmation.sendAgain')"
                         @confirm="sendLinkAgain"
                        :bottomLinkDescription="true"
    :cancel-button="false"/>
  </div>
</template>

<script>
import errorMessageHandler from '@/mixins/errorMessageHandler'
import ConfirmationModal from '@/components/common/modal/confirmation-modal'

export default {
  name: 'email-address-change',
  components: { ConfirmationModal },
  data () {
    return {
      confirmEmailChangeVisible: false,
      emailInput: '',
      passwordInput: '',
      buttonDisabled: false,
      dataLoading: false,
      changeEmailSubmitted: false,
      oldEmail: ''
    }
  },
  mixins: [errorMessageHandler],
  computed: {
    changeEmailFormFilled () {
      return !!this.emailInput && !!this.passwordInput
    }
  },
  methods: {
    sendLinkAgain () {
      this.$apiRequest.put('/user/login', { newLogin: this.emailInput, password: this.passwordInput })
        .then((response) => {
          if (response.status === 200) {
            this.confirmEmailChangeVisible = false
            this.toast('success', {
              message: this.$t('toastMessages.successChangeEmailRequestMessage')
            })
          }
        })
        .catch(e => {
          this.handleErrorMessage(e.response.data)
        })
    },
    fetchUserInfo () {
      this.$apiRequest.get('user/info')
        .then(response => {
          this.oldEmail = response.data.displayUid || ''
        })
        .catch(e => {
          this.handleErrorMessage(e.response.data)
        })
    },
    async submitChangeEmail () {
      this.changeEmailSubmitted = true
      const valid = await this.$refs.changeEmail.validate()

      if (valid) {
        this.dataLoading = true
        this.$apiRequest.put('/user/login', { newLogin: this.emailInput, password: this.passwordInput })
          .then((response) => {
            if (response.status === 200) {
              this.confirmEmailChangeVisible = true
            }
          })
          .catch(e => {
            this.handleErrorMessage(e.response.data)
          })
          .finally(() => {
            this.dataLoading = false
            this.buttonDisabled = false
          })
      } else {
        this.dataLoading = false
      }
    },
    resetData () {
      this.confirmEmailChangeVisible = false
      this.emailInput = ''
      this.passwordInput = ''
      this.changeEmailSubmitted = false
    }
  },
  mounted () {
    this.fetchUserInfo()
  }
}
</script>

<style lang="scss" scoped>
.email-address-change {
  padding-top: 2rem;

  .change-address-form{
    width: 100%;

    @media (map_get($breakpoints, sm)) {
      width: 360px;
    }

    .save-btn {
      width: 100%;
      margin-top: 1rem;

      @media (map_get($breakpoints, sm)) {
        width: auto;
      }
    }
  }
}

</style>
